// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  text-decoration: none;
  margin: 0;
  box-sizing: border-box;
  font-family: Nunito, sans-serif;
}

button {
  padding: 2px 16px;
  span {
    font-size: 16px !important;
  }
}

#scrollableDiv,
.list {
  overflow: auto;
  padding: 0 16px;
  border: 1px solid rgba(140, 140, 140, 0.35);
}

#scrollableDiv::-webkit-scrollbar,
.list::-webkit-scrollbar {
  width: 6px;
  /* width of the entire scrollbar */
}

#scrollableDiv::-webkit-scrollbar-track,
.list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  /* color of the tracking area */
}

#scrollableDiv::-webkit-scrollbar-thumb,
.list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  /* border: 3px solid rgba(0, 0, 0, 0.2); */
  /* creates padding around scroll thumb */
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,SAAS;EACT,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,2CAA2C;AAC7C;;AAEA;;EAEE,UAAU;EACV,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,wCAAwC;AAC1C","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap\");\n\n* {\n  padding: 0;\n  text-decoration: none;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: Nunito, sans-serif;\n}\n\nbutton {\n  padding: 2px 16px;\n  span {\n    font-size: 16px !important;\n  }\n}\n\n#scrollableDiv,\n.list {\n  overflow: auto;\n  padding: 0 16px;\n  border: 1px solid rgba(140, 140, 140, 0.35);\n}\n\n#scrollableDiv::-webkit-scrollbar,\n.list::-webkit-scrollbar {\n  width: 6px;\n  /* width of the entire scrollbar */\n}\n\n#scrollableDiv::-webkit-scrollbar-track,\n.list::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1);\n  /* color of the tracking area */\n}\n\n#scrollableDiv::-webkit-scrollbar-thumb,\n.list::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.3);\n  /* color of the scroll thumb */\n  border-radius: 20px;\n  /* roundness of the scroll thumb */\n  /* border: 3px solid rgba(0, 0, 0, 0.2); */\n  /* creates padding around scroll thumb */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
